import {
    FETCH_POSTS_REQUEST,
    FETCH_POSTS_SUCCESS,
    FETCH_POSTS_FAILURE,
    CREATE_POST_REQUEST,
    CREATE_POST_SUCCESS,
    CREATE_POST_FAILURE,
    RESET_NEW_POST,
    UPDATE_NEW_POST,
    LIKE_POST_REQUEST,
    LIKE_POST_SUCCESS,
    LIKE_POST_FAILURE,
    UNLIKE_POST_REQUEST,
    UNLIKE_POST_SUCCESS,
    UNLIKE_POST_FAILURE,
    ADD_COMMENT_REQUEST,
    ADD_COMMENT_SUCCESS,
    ADD_COMMENT_FAILURE
  } from '../actions/blogActions';
  
  const initialState = {
    posts: [],
    loading: false,
    error: null,
    newPost: {
      title: '',
      description: '',
      media: [],
    },
    filter: 'All',
  };
  
  const postReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_POSTS_REQUEST:
      case CREATE_POST_REQUEST:
      case LIKE_POST_REQUEST:
      case UNLIKE_POST_REQUEST:
      case ADD_COMMENT_REQUEST:
        return { ...state, loading: true, error: null };
  
      case FETCH_POSTS_SUCCESS:
        return { ...state, loading: false, posts: action.payload };
  
      case FETCH_POSTS_FAILURE:
      case CREATE_POST_FAILURE:
      case LIKE_POST_FAILURE:
      case UNLIKE_POST_FAILURE:
      case ADD_COMMENT_FAILURE:
        return { ...state, loading: false, error: action.error };
  
      case CREATE_POST_SUCCESS:
        return { ...state, loading: false, posts: [action.payload, ...state.posts] };
  
      case LIKE_POST_SUCCESS: {
        const updatedPosts = state.posts.map(post =>
          post.id === action.payload.postId ? { ...post, likes: action.payload.likes } : post
        );
        return { ...state, loading: false, posts: updatedPosts };
      }
  
      case UNLIKE_POST_SUCCESS: {
        const updatedPosts = state.posts.map(post =>
          post.id === action.payload.postId ? { ...post, likes: post.likes - 1 } : post
        );
        return { ...state, loading: false, posts: updatedPosts };
      }
  
      case ADD_COMMENT_SUCCESS: {
        const updatedPosts = state.posts.map(post =>
          post.id === action.payload.postId ? { ...post, comments: [...post.comments, action.payload.comment] } : post
        );
        return { ...state, loading: false, posts: updatedPosts };
      }
  
      case RESET_NEW_POST:
        return { ...state, newPost: { title: '', description: '', media: [] } };
  
      case UPDATE_NEW_POST:
        return { ...state, newPost: { ...state.newPost, ...action.payload } };
  
      case 'SET_FILTER':
        return { ...state, filter: action.payload };
  
      default:
        return state;
    }
  };
  
  export default postReducer;
  